import React, { FC, useEffect, useRef } from 'react';

import styles from './index.module.less';

interface NumberItemProps {
  /** 1: 数字 ,: 千分号 .: 小数点 */
  number: string;
  color?: string;
  fontSize?: number;
  fontFamily?: string;
  speed?: number;
  className?: string;
}

const nums = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];

export const NumberItem: FC<NumberItemProps> = (props) => {
  const {
    number = '0',
    fontSize = 16,
    fontFamily = 'DINPro-Medium"',
    color = '#ccc',
    speed = 200,
    className
  } = props;
  const spanDom = useRef<HTMLSpanElement>();
  const num = Number(number);

  useEffect(() => {
    if (!spanDom.current) return;
    spanDom.current.style.transition = `transform ${
      (num * speed) / 1000
    }s ease-in-out`;
    spanDom.current.style.transform = `translateY(-${num * fontSize * 1.5}px)`; // 之所以要*1.5 是为了解决符号展示不全的问题
  }, [number, fontSize, speed]);

  if (isNaN(num)) {
    // ,(千分位) .(小数点) 情况是NaN
    return (
      <span
        className={styles.separator}
        style={{
          fontSize: `${fontSize}px`,
          fontFamily,
          color,
          lineHeight: '1.5'
        }}
      >
        {number}
      </span>
    );
  }

  return (
    <span
      className={styles.numContainer}
      style={{
        fontSize: `${fontSize}px`,
        lineHeight: '1.5',
        height: `${fontSize * 1.5}px`
      }}
    >
      <span className={styles.numItem} ref={spanDom}>
        {nums.map((item) => (
          <span
            key={item}
            className={className}
            style={{
              fontSize: `${fontSize}px`,
              fontFamily,
              color,
              lineHeight: '1.5'
            }}
          >
            {item}
          </span>
        ))}
      </span>
    </span>
  );
};
